import { styled, keyframes } from "../../styles";

const spin = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" },
});

export const MainContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100dvh",
  backgroundColor: "$gray-5",
  padding: "20px",
  fontFamily: "$openSans",
  boxSizing: "border-box",

  "@sm": {
    padding: "16px",
  },
});

export const Card = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "white",
  borderRadius: "12px",
  padding: "48px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  maxWidth: "440px",
  width: "100%",
  textAlign: "center",
  boxSizing: "border-box",

  "@sm": {
    padding: "32px 24px",
    borderRadius: "16px",
  },
});

export const Logo = styled("img", {
  width: "180px",
  marginBottom: "32px",

  "@sm": {
    width: "150px",
    marginBottom: "24px",
  },
});

export const IconContainer = styled("div", {
  width: "72px",
  height: "72px",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "24px",

  "@sm": {
    width: "64px",
    height: "64px",
    marginBottom: "20px",
  },

  variants: {
    status: {
      loading: {
        backgroundColor: "$primary-5",
      },
      success: {
        backgroundColor: "$success-lightest",
      },
      error: {
        backgroundColor: "$error-lightest",
      },
    },
  },
});

export const Spinner = styled("div", {
  width: "36px",
  height: "36px",
  border: "3px solid $primary-10",
  borderTop: "3px solid $primary-40",
  borderRadius: "50%",
  animation: `${spin} 1s linear infinite`,

  "@sm": {
    width: "32px",
    height: "32px",
  },
});

export const Title = styled("h1", {
  color: "$gray-100",
  marginBottom: "12px",
  marginTop: 0,
  fontSize: "24px",
  fontWeight: "600",
  lineHeight: "32px",

  "@sm": {
    fontSize: "22px",
    lineHeight: "28px",
    marginBottom: "8px",
  },
});

export const Message = styled("p", {
  color: "$gray-60",
  fontSize: "16px",
  lineHeight: "24px",
  marginBottom: "16px",
  marginTop: 0,
  maxWidth: "320px",

  "@sm": {
    fontSize: "15px",
    lineHeight: "22px",
    marginBottom: "12px",
  },
});

export const InfoText = styled("p", {
  color: "$gray-40",
  fontSize: "14px",
  lineHeight: "20px",
  marginTop: "8px",
  marginBottom: 0,

  "@sm": {
    fontSize: "13px",
    lineHeight: "18px",
  },
});
